<script setup lang="ts">
import { ChevronRight } from "@lucide/vue";
import { computed } from "vue";
import PageHeader from "@/components/common/PageHeader.vue";
import { Card } from "@/components/ui/card";
import { ADMIN_ELSEWHERE, NAV } from "@/components/shell/nav";
import { useSession } from "@/composables/useSession";
import { t } from "@/copy/strings";

definePage({ meta: { title: "Administration", requires: { anyAdmin: true } } });

const DESCRIPTIONS: Record<string, string> = {
  "/admin/access": "Roles, grants, who has which role, and the access simulator.",
  "/admin/users": t.admin.usersDescription,
  "/admin/datasources": t.admin.datasourcesDescription,
  "/admin/connection-providers": t.admin.connectionProvidersDescription,
  "/admin/mcp-clients": t.admin.mcpClientsDescription,
  "/admin/ai": t.admin.aiDescription,
  "/admin/runbooks": t.admin.runbooksDescription,
  "/knowledge/sources": t.knowledge.sourcesDescription,
  "/admin/feedback": t.feedback.description,
  "/admin/settings": t.admin.settingsDescription,
  "/admin/system": t.admin.systemDescription,
};

const { allows } = useSession();
const areas = computed(() => [...(NAV.find((s) => s.id === "admin")?.items ?? []), ...ADMIN_ELSEWHERE].filter((i) => allows(i.requires)));
</script>

<template>
  <div>
    <PageHeader :title="t.admin.title" description="Everything that configures Smake. Every change here is audited." />
    <ul class="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      <li v-for="a in areas" :key="a.to" class="min-w-0">
        <Card as-child variant="interactive" padding="sm" class="group h-full flex-row items-start gap-3">
          <RouterLink :to="a.to">
            <span class="grid size-9 shrink-0 place-items-center rounded-lg bg-accent text-accent-foreground"><component :is="a.icon" class="size-4" aria-hidden="true" /></span>
            <span class="min-w-0 flex-1">
              <span class="block font-medium">{{ a.label }}</span>
              <span class="mt-0.5 block text-sm text-muted-foreground">{{ DESCRIPTIONS[a.to] }}</span>
            </span>
            <ChevronRight class="mt-1 size-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
          </RouterLink>
        </Card>
      </li>
    </ul>
  </div>
</template>
